<div class="dialog">
  <div mat-dialog-title>Create a Security Model<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
</div>
<mat-dialog-content>
  @if (modelNameInUse) {
    <mat-card class="error block">
      <mat-card-title class="error">This name is already in use for a model</mat-card-title>
      <mat-card-subtitle>Please provide another one.</mat-card-subtitle>
    </mat-card>
  }
  <div class="bottomPaddingElementDialog">{{callToActionText}}</div>
  <table width="100%">
    <tr>
      <th align="left" style="vertical-align: top;"><label>Model Type:</label></th>
      <td>
        <div class="block"><strong>Security</strong></div>
        <div class="block">You'll select the securities for this model when you continue</div>
      </td>
    </tr>
    <tr>
      <th align="left" style="vertical-align: top;"><label>Model Name:</label></th>
      <td>
        <div class="block">
          <span tooltip [tooltipTitle]="tooltipMessage" tooltipClass="error" tooltipPosition="right">
            <irb-validation-text-box #modelNameField [(value)]="modelName" (change)="onInputChange()" width="400px" max="100"></irb-validation-text-box>
          </span>
        </div>
        <div class="block">You can always edit this later</div>
      </td>
    </tr>
    <tr>
      <th align="left" style="vertical-align: top;"><label>Description</label></th>
      <td>
        <div class="block">
          <span tooltip [tooltipTitle]="tooltipDescMessage" tooltipClass="error" tooltipPosition="right"><irb-validation-text-box #modelDescField [(value)]="modelDesc" (change)="onDescChange()" width="400px" max="100"></irb-validation-text-box></span>
        </div>
      </td>
    </tr>
  </table>
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
  <button id="continueButton" (click)="checkIfNameExists()" class="btn-medium-primary" [disabled]="canNotContinue">
    Continue
  </button>
</mat-dialog-actions>
</div>
